export default __webpack_public_path__ + "static/media/enterpriseCompliance.f2f59d88.png";